module.exports = __webpack_public_path__ + "static/img/hussar_recommendations_face.42f8e17.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_recommendations_face.webp
// module id = BIXo
// module chunks = 0